export const OPPORTUNITY_TYPE = {
  VET: 'VET',
  VTO: 'VTO',
  DSVTO: 'DSVTO'
};

// DSVTO is treated as a kind of VTO. Sole encoding of that rule — both
// summary roll-ups and tag/color mappings derive from it.
export const VTO_OPPORTUNITY_TYPES = new Set([OPPORTUNITY_TYPE.VTO, OPPORTUNITY_TYPE.DSVTO]);

export const TYPE_TO_TAG = {
  [OPPORTUNITY_TYPE.VET]: 'error',
  [OPPORTUNITY_TYPE.VTO]: 'success',
  [OPPORTUNITY_TYPE.DSVTO]: 'success'
};

export const TINT_RGB = {
  VET: [209, 50, 18],
  VTO: [29, 129, 2]
};
